module.exports = __webpack_public_path__ + "img/change-gray.fe3c7c4a.svg";